import { AfterViewInit, Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { of } from 'rxjs';
import { CategorieUm } from 'src/app/services/unita-di-misura/unita-di-misura.service';
import { Colonna, Riga } from '../tabella-cfg-dinamica.component';

@Component({
  selector: 'app-edit-tabella-dinamica-bottom-sheet',
  standalone: false,

  templateUrl: './edit-tabella-dinamica-bottom-sheet.component.html',
  styleUrl: './edit-tabella-dinamica-bottom-sheet.component.scss',
})
export class EditTabellaDinamicaBottomSheetComponent implements AfterViewInit {
  public categoriaUnitaSelezionata: CategorieUm | undefined = undefined;
  public infiniteRecords: number = Infinity;
  public arrayTipologiaColonna = [
    {
      chiave: 'TESTO',
      valore: 'Testuale',
    },
    {
      chiave: 'BOOLEAN',
      valore: 'Si / No',
    },
    {
      chiave: 'UM',
      valore: 'Unità di Misura',
    },
  ];

  colonna: Colonna = {
    id: '',
    label: '',
    idCatUm: undefined,
    tipoColonna: undefined,
    unitaDiMisura: undefined,
  };

  riga: Riga = {
    id: '',
    label: '',
    celle: {},
  };

  constructor(
    private readonly bottomSheetRef: MatBottomSheetRef<EditTabellaDinamicaBottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: {
      elemento: any;
      tipo: string;
      arrayCategorie: CategorieUm[];
    },
  ) {
    if (data.elemento) {
      switch (data.tipo) {
        case 'COLONNA': {
          this.colonna = data.elemento;

          if (this.colonna.tipoColonna === 'UM') {
            this.categoriaUnitaSelezionata = this.data.arrayCategorie.find(
              (cat) => cat.id === this.colonna.idCatUm,
            );
          }

          break;
        }
        case 'RIGA':
          this.riga = data.elemento;
          break;
        default:
          break;
      }
    }
  }
  ngAfterViewInit(): void {
    this.bottomSheetRef.backdropClick().subscribe(() => {
      this.dismissElemento(false);
    });
  }

  compareById(elemento1: any, elemento2: any): boolean {
    return elemento1?.id === elemento2?.id;
  }
  /* Gesture con variabile di output e passare l'id da eliminare */
  /*   rimuoviRiga(riga: Riga) {
      this.righe = this.righe.filter(r => r.id !== riga.id); // crea nuovo array
      delete riga.celle[riga.id];
    } */

  displayFn(categoria: CategorieUm): string {
    return categoria?.nome ?? '';
  }

  /**
   * loading FN per autocomplete delle categorie
   * @param id
   * @param txtRicerca
   * @returns
   */
  loadDataFnGetCategorie = (id: any, txtRicerca: string) => {
    let records: CategorieUm[] = [];

    if (id) {
      records = this.data.arrayCategorie.filter((option) => option.id?.toLowerCase() === id);
    } else if (txtRicerca) {
      records = this._filter(txtRicerca);
    } else {
      records = this.data.arrayCategorie.slice();
    }

    return of(records);
  };

  private _filter(categoria: string): CategorieUm[] {
    const filterValue = categoria.toLowerCase();
    return this.data.arrayCategorie.filter((option) =>
      option.nome?.toLowerCase().includes(filterValue),
    );
  }

  elimina(): void {
    this.dismissElemento(true);
  }

  chiudi(): void {
    this.dismissElemento(false);
  }

  /**
   * Chiusura bottomsheet
   * @param isElimina
   */
  private dismissElemento(isElimina: boolean): void {
    const tipo = this.data.tipo;

    if (tipo === 'COLONNA') {
      this.colonna.idCatUm = this.categoriaUnitaSelezionata?.id;
      this.bottomSheetRef.dismiss({
        colonna: this.colonna,
        isElimina,
      });
    } else if (tipo === 'RIGA') {
      this.bottomSheetRef.dismiss({
        riga: this.riga,
        isElimina,
      });
    }
  }
}
